import { CommentStatus } from '@src/store/contentEntities/model';
import { jotaiStore } from '@src/store/store';
import { commentsAtom } from '../comments';

export function getComment(commentId: string) {
    const commentFromJotai = jotaiStore.get(commentsAtom)[commentId];
    return commentFromJotai;
}

export function isCommentDeleted(commentId: string) {
    const comment = getComment(commentId);
    if (!comment) return false;
    return [
        CommentStatus.DELETED_BY_CATEGORY_ADMIN, // Deprecated
        CommentStatus.DELETED_BY_PUBLISHER,
        CommentStatus.DELETED_BY_DOMAIN_ADMIN,
        CommentStatus.DELETED_BY_TOKEN_ADMIN,
    ].includes(comment?.status);
}
